var styles = {"fontElementMap":"yYrdP","orderedlist":"nJFUn","bulletedlist":"GIAjj","listItem":"gwM-N"};

export { styles as s };
//# sourceMappingURL=lists-58f099ed.js.map
